import { Component, inject } from "@angular/core";
import { Auth } from "@angular/fire/auth";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Store } from "@ngxs/store";
import { User } from "src/app/state/user-state/user.actions";
import { IUser, Modify, UUID } from "src/app/core/interfaces";
import { UserState } from "src/app/state/user-state/user.state";

@Component({
  selector: "app-two-factor-dialog",
  templateUrl: "./two-factor-dialog.component.html",
  styleUrls: ["./two-factor-dialog.component.scss"],
})
export class TwoFactorDialogComponent {
  constructor(public dialogRef: MatDialogRef<TwoFactorDialogComponent>) {}
  private router: Router = inject(Router);
  private auth = inject(Auth);
  private store = inject(Store);

  onNoClick(): void {
    this.dialogRef.close();
  }

  decline2FA(): void {
    const loggedInUser = this.auth.currentUser?.uid;
    const user = this.store.selectSnapshot(UserState.getCurrentUser);

    if (loggedInUser && user) {
      const updatedUser: Modify<IUser, { id: UUID }> = {
        ...user,
        skipTwoFactor: true,
        id: loggedInUser,
      };
      this.store.dispatch(new User.Update(updatedUser));
      this.store.dispatch(new User.Get(loggedInUser));
    }
    this.dialogRef.close();
  }

  navigate2FA(): void {
    const userType = this.store.selectSnapshot(UserState.getCurrentUser).userType;

    this.router.navigate([`${userType}/settings/profile`]);
    this.dialogRef.close();
  }
}
